const deliveryTypeLabels = {
  delivery: "دریافت_درب_منزل",
  selfPickup: "بیرون_بر",
  dineIn: "سالن",
  cinema: "سینما"
}

export default deliveryTypeLabels